import defaultConfig from '@onereach/styles/tailwind.config.json';

const useTheme = () => {
  return defaultConfig.theme;
};

export { useTheme as u };
